import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { navGroups } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function DesktopNav() {
  const [openId, setOpenId] = useState<string | null>(null);
  const navRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (!openId) return;
    const onPointerDown = (e: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(e.target as Node)) setOpenId(null);
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        const current = openId;
        setOpenId(null);
        document.getElementById(`nav-btn-${current}`)?.focus();
      }
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [openId]);
  const handleBlur = (e: React.FocusEvent<HTMLLIElement>) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setOpenId(null);
  };
  return <nav ref={navRef} aria-label="Main" className="hidden nav:block" data-id="element-93" data-mp="nhqiuewo116j">
      <ul className="flex items-center gap-1" data-id="element-94" data-mp="125l97on7atgg">
        {navGroups.map(group => {
        const isOpen = openId === group.id;
        return <li key={group.id} className="relative" onBlur={handleBlur} data-id="element-95" data-mp="9i7m0i9b1c9j">
              <button id={`nav-btn-${group.id}`} type="button" aria-expanded={isOpen} aria-controls={`nav-panel-${group.id}`} onClick={() => setOpenId(isOpen ? null : group.id)} className={`inline-flex min-h-[48px] items-center gap-1.5 rounded-md px-3 text-label font-semibold ${isOpen ? "bg-mist text-ink" : "text-ink hover:text-crimson"}`} data-id="element-96" data-mp="9ih99y2yt5bj">
                {group.label}
                <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 text-slate ${isOpen ? "rotate-180" : ""}`} data-id="element-97" data-mp="mljx57o6ap1z" />
              </button>
              {isOpen && <div id={`nav-panel-${group.id}`} className="absolute left-0 top-full z-20 mt-2 w-[340px] rounded-lg border border-line bg-white p-2 shadow-[0_12px_32px_rgba(19,42,58,0.12)]" data-id="element-98" data-mp="wj7t20xim2lq">
                  <ul data-id="element-99" data-mp="3wmyyspnnceh">
                    {group.links.map(link => <li key={link.path} data-id="element-100" data-mp="8v814xogw65k">
                        <SiteLink path={link.path} onClick={() => setOpenId(null)} className="flex min-h-[48px] items-center rounded-md px-4 py-2.5 text-label font-semibold text-ink hover:bg-ivory hover:text-crimson" data-id="element-101" data-mp="8rslntqvsv3m">
                          {link.label}
                        </SiteLink>
                      </li>)}
                  </ul>
                </div>}
            </li>;
      })}
      </ul>
    </nav>;
}